import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

const useDeleteSeederOrder = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation(
    (orderId: number) => {
      return fetch(`${API}/api/semeadora/orders/${orderId}/`, {
        method: "DELETE",
      });
    },
    {
      onSuccess: () => {
        // Invalidar cache para recarregar a lista de pedidos
        queryClient.invalidateQueries(["seeder-orders"]);
      },
    },
  );
};

export default useDeleteSeederOrder;
